import { useEffect, useState } from "react";
import axios from "axios";
import { Sparkles, X } from "lucide-react";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import Storia from "@/components/landing/Storia";
import Gusti from "@/components/landing/Gusti";
import Semifreddi from "@/components/landing/Semifreddi";
import Lievitati from "@/components/landing/Lievitati";
import Orari from "@/components/landing/Orari";
import Recensioni from "@/components/landing/Recensioni";
import Contatti from "@/components/landing/Contatti";
import Footer from "@/components/landing/Footer";
import ChatWidget from "@/components/landing/ChatWidget";
import { computeOpenStatus } from "@/lib/status";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Landing() {
  const [hours, setHours] = useState(null);
  const [announcement, setAnnouncement] = useState(null);
  const [dismissed, setDismissed] = useState(null);

  useEffect(() => {
    axios.get(`${API}/settings/hours`).then((r) => setHours(r.data)).catch(() => {});
    axios.get(`${API}/settings/announcement`).then((r) => setAnnouncement(r.data)).catch(() => {});
    setDismissed(sessionStorage.getItem("imperiale_annuncio_chiuso"));
  }, []);

  const status = computeOpenStatus(hours);
  const showBanner = announcement?.active && announcement.text && dismissed !== announcement.text;

  const closeBanner = () => {
    sessionStorage.setItem("imperiale_annuncio_chiuso", announcement.text);
    setDismissed(announcement.text);
  };

  return (
    <main data-testid="landing-page" className="bg-[#FDFBF7] text-ink overflow-x-clip">
      {showBanner && (
        <div
          data-testid="annuncio-banner"
          className="fixed inset-x-0 top-0 z-[55] flex h-11 items-center justify-center gap-2.5 bg-bordeaux px-12 text-ivory"
        >
          <Sparkles className="h-3.5 w-3.5 shrink-0 text-gold" />
          <p data-testid="annuncio-text" className="truncate font-mono-alt text-[11px] uppercase tracking-[0.18em]">
            {announcement.text}
          </p>
          <button
            data-testid="annuncio-close"
            onClick={closeBanner}
            className="absolute right-4 flex h-7 w-7 items-center justify-center rounded-full transition-colors hover:bg-ivory/15"
            aria-label="Chiudi annuncio"
          >
            <X className="h-3.5 w-3.5" />
          </button>
        </div>
      )}
      <Navbar bannerVisible={showBanner} />
      <Hero status={status} />
      <Marquee />
      <Storia />
      <Gusti />
      <Semifreddi />
      <Lievitati />
      <Orari hours={hours} status={status} />
      <Recensioni />
      <Contatti />
      <Footer />
      <ChatWidget />
    </main>
  );
}
